import { render, staticRenderFns } from "./TechSupportPage.vue?vue&type=template&id=3ddf0564&scoped=true"
import script from "./TechSupportPage.vue?vue&type=script&lang=js"
export * from "./TechSupportPage.vue?vue&type=script&lang=js"
import style0 from "./TechSupportPage.vue?vue&type=style&index=0&id=3ddf0564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddf0564",
  null
  
)

export default component.exports